import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../base-form/base-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-form',
  templateUrl: '../base-form/base-form.component.html',
  styleUrls: ['./form.component.scss', '../base-form/base-form.component.scss']
})
export class FormComponent extends BaseFormComponent implements OnInit {
  entityName = this.route.snapshot.data.entityName;
  constructor(public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
  }

}
